import { CampProps } from "~/interfaces"
import parseDateTime from "../parseDateTime"

export const formatDate = (dateStr: string, camp: CampProps) => {
  if (!dateStr) return "-"

  const parsedDate = parseDateTime(dateStr, camp.timezone)
  if (!parsedDate?.isValid) return "-"

  return parsedDate.toFormat(camp.date_format.replace(/DD/g, "dd").replace(/YYYY/g, "yyyy"))
}
